<template>
  <div>
    <div v-if="applicationData && questionData && categorizationsData && userData" style="padding: 1rem;">
      <dialog id="purchase-modal">
        <svg @click="closeModal('purchase-modal');" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <div class="purchase-modal-content">
          <div v-if="applicationData.is_free" id="free-container">
            <div class="layout-left">
              <h4>Review Order</h4>
              <p>
                This is App is Free
              </p>
            </div>
            <div class="layout-right">
              <h4>Order Summary</h4>
              <div class="total-price">
                <div>Total</div>
                <span>{{ applicationData.currency_code }} 0.00</span>
              </div>
              <button class="primary-button-sm-global" @click="testingPayment">Checkout</button>
            </div>
          </div>
          <div v-else id="cost-container">
            <div id="payment-info-container" class="layout-left">
              <h4>Payment Method</h4>
              <div :class="['payment-method-card', paymentMethod == 'credit' ? 'selected-payment-method' : null]" @click="paymentMethod = 'credit'">
                <span>
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#FFE8C0"/>
                    <path d="M27.5002 13.334H12.5002C11.5797 13.334 10.8335 14.0802 10.8335 15.0007V25.0007C10.8335 25.9211 11.5797 26.6673 12.5002 26.6673H27.5002C28.4206 26.6673 29.1668 25.9211 29.1668 25.0007V15.0007C29.1668 14.0802 28.4206 13.334 27.5002 13.334Z" stroke="#D57900" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.8335 18.334H29.1668" stroke="#D57900" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Credit Card</span>
                </span>
                <span><input type="radio" v-model="paymentMethod" name="payment-plan-payment" value="credit" /></span>
              </div>
              <div :class="['payment-method-card', paymentMethod == 'payPal' ? 'selected-payment-method' : null]" @click="paymentMethod = 'payPal'">
                <span>
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="20" cy="20" r="20" fill="#FFE8C0"/>
                    <path d="M15.2449 14.0305L13.4708 24.7271C13.3208 25.628 13.2466 26.0788 13.4958 26.373C13.7433 26.668 14.1974 26.668 15.1066 26.668H15.4416C16.1274 26.668 16.4699 26.668 16.7041 26.4646C16.9374 26.2605 16.9866 25.9196 17.0833 25.2371L17.4733 22.4955C17.5041 22.2788 17.5191 22.1705 17.5433 22.078C17.627 21.7538 17.8069 21.4625 18.0593 21.2425C18.3117 21.0226 18.6248 20.8841 18.9574 20.8455C19.0516 20.8346 19.1608 20.8346 19.3783 20.8346H20.3466C21.6016 20.8324 22.8186 20.4034 23.7975 19.618C24.7764 18.8327 25.459 17.7377 25.7333 16.513C26.2949 14.0313 24.4183 11.668 21.8858 11.668H18.0191C17.0908 11.668 16.6274 11.668 16.2608 11.8638C16.0524 11.9755 15.8691 12.1305 15.7258 12.3196C15.4733 12.6505 15.3974 13.1105 15.2449 14.0305Z" stroke="#D57900" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.8692 26.252L16.6792 27.362C16.5917 27.8703 16.9875 28.3353 17.5092 28.3353H19.1675C19.58 28.3353 19.9317 28.0403 19.9992 27.6386L20.6075 24.0311C20.6742 23.6295 21.0267 23.3353 21.4383 23.3353H22.9408C25.0917 23.3353 26.9542 21.8578 27.4208 19.7811C27.7475 18.327 27.0367 16.927 25.8333 16.252" stroke="#D57900" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Pay Pal</span>
                </span>
                <span><input type="radio" v-model="paymentMethod" name="payment-plan-payment" value="payPal" /></span>
              </div>
              <div v-if="paymentMethod == 'credit'" id="payment-info">
                <div>
                  <div>First Name</div>
                  <input type="text" placeholder="First Name" />
                </div>
                <div>
                  <div>Last Name</div>
                  <input type="text" placeholder="Last Name" />
                </div>
                <div class="span2Col">
                  <div>Card Number</div>
                  <input type="text" placeholder="Card Number"/>
                </div>
                <div>
                  <div>Expiration Date</div>
                  <input type="text" placeholder="MM/YY"/>
                </div>
                <div>
                  <div>Security Code</div>
                  <input type="text" maxlength="3" style="width: 4rem;" placeholder="3 digits" />
                </div>
                <h4 style="margin-top: 1rem;" class="span2Col">Billing Information</h4>
                <div>
                  <div>Address</div>
                  <input type="text" placeholder="Address" />
                </div>
                <div>
                  <div>City</div>
                  <input type="text" placeholder="City" />
                </div>
                <div>
                  <div> State/Province/Region</div>
                  <input type="text" placeholder="State/Province/Region" />
                </div>
                <div>
                  <div>Postal Code/Zip Code</div>
                  <input type="text" placeholder="Postal Code/Zip Code" />
                </div>
                <div>
                  <div>Country</div>
                  <input type="text" placeholder="Country" />
                </div>
                <div>
                  <div>Phone Number</div>
                  <input type="tel" placeholder="Enter Phone Number" />
                </div>
              </div>
              <div v-else-if="paymentMethod == 'payPal'" id="payPal-info">
                <div>PayPal transactions are processed securely on the PayPal website. Click the button below to open a new browser window and start the payment process. You’ll have the opportunity to review your order before completing the purchase.</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5 .5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3 .5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5 .1-9.8-6.9-15.5-16.2-15.5z"/></svg>
              </div>
            </div>
            <div id="plan-info-checkout-container" class="layout-right">
              <div v-if="applicationData.single_unit_pricing" id="unit-plan-container" @click="paymentPlan = 'unit'">
                <div class="type-header">
                  <div>Purchase By Unit</div>
                  <span><input type="radio" v-model="paymentPlan" name="payment-plan-checkout" value="unit" /></span>
                </div>
                <div class="price-header">
                  <span>{{ getCurrencySymbol(applicationData.currency_code) }}{{ applicationData.single_unit_pricing  }}</span>per unit
                  <div>
                    <span style="font-weight: 700;">Select Quantity</span>
                    <div class="custom-quantity-input">
                      <button @click="customQuantityChooser('decrement')">-</button>
                      <span class="custom-quantity-input-number">{{ this.paymentInputObject.numberOfUnits }}</span>
                      <button @click="customQuantityChooser('increment')">+</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="applicationData.monthly_subscription_pricing" id="monthly-plan-container" @click="paymentPlan = 'monthly'">
                <div class="type-header">
                  <div>Purchase By Subscription</div>
                  <span><input type="radio" v-model="paymentPlan" name="payment-plan-checkout" value="monthly" /></span>
                </div>
                <div class="price-header">
                  <span>{{ getCurrencySymbol(applicationData.currency_code) }}{{ applicationData.monthly_subscription_pricing }}</span> monthly
                </div>
              </div>
              <div>
                <div><b>Pricing</b></div>
                <span v-if="paymentPlan == 'monthly'">
                  <span>{{ getCurrencySymbol(applicationData.currency_code) }}{{ applicationData.monthly_subscription_pricing }} / Month</span>
                  <div style="display: flex; justify-content: space-between;">
                    <span>1 Month</span>
                    <span>{{ getCurrencySymbol(applicationData.currency_code) }}{{ applicationData.monthly_subscription_pricing }}</span>
                  </div>
                  <div style="border-top: 1px solid #B9B9B9;"></div>
                  <div style="display: flex; justify-content: space-between;">
                    <b>Total</b>
                    <b>{{ getCurrencySymbol(applicationData.currency_code) }}{{ applicationData.monthly_subscription_pricing }}</b>
                  </div>
                </span>
                <span v-else-if="paymentPlan == 'unit'">
                  <div style="display: flex; justify-content: space-between;">
                    1 Unit x {{ paymentInputObject.numberOfUnits }}
                    <span>{{ getCurrencySymbol(applicationData.currency_code) }}{{ totalPrice }}</span>
                  </div>
                  <div style="border-top: 1px solid #B9B9B9;"></div>
                  <div style="display: flex; justify-content: space-between;">
                    <b>Total</b>
                    <b>{{ getCurrencySymbol(applicationData.currency_code) }}{{ totalPrice }}</b>
                  </div>
                </span>
              </div>
              <button class="primary-button-sm-global" @click="testingPayment" style="color: red; font-weight: 700;">TESTING PURPOSES TO SKIP PAYMENT (REMOVE LATER)</button>
            </div>
          </div>
        </div>
      </dialog>
      <dialog id="receipt-modal">
        <h2>Thank You!</h2>
        <div>
          You will be able to see your application in your activities page.
          <div style="display: flex; justify-content: flex-end; margin-top: 1rem;">
            <button class="secondary-gray-button-sm-global" style="margin-right: 5px;" @click="closeModal('receipt-modal');">Return to Marketplace</button>
            <button class="primary-button-sm-global" @click="goToActivities">Go to Activities</button>
          </div>
        </div>
      </dialog>
      <div id="dynamic-page-grid">
        <div>
          <img v-if="applicationData.image != ''" :src="`${reverseProxy}/api/${applicationData.image}`" alt="Picture N/A" loading="lazy" />
          <img v-else :src="getURLImage(applicationData.image)" />
<!--           <div id="preview-button">
            <button>
              <router-link :to="`/appTester/${applicationID}`">
                Preview {{ applicationData.title }}
              </router-link>
            </button>
          </div> -->
          <div id="application-base-info">
            <div class="column-grid">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <b>Cognitive skills</b>
                <small>Area</small>
              </div>
            </div>
            <div class="column-grid">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <b>{{ (applicationData.age_range).match(/\d+/g).join("-") }}</b>
                <small>Age Range</small>
              </div>
            </div>
            <div class="column-grid">
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9.08984 9.00057C9.32495 8.33224 9.789 7.76868 10.3998 7.4097C11.0106 7.05073 11.7287 6.91951 12.427 7.03928C13.1253 7.15906 13.7587 7.52209 14.2149 8.0641C14.6712 8.6061 14.9209 9.29209 14.9198 10.0006C14.9198 12.0006 11.9198 13.0006 11.9198 13.0006" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 17H12.01" stroke="#696969" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <b>{{ questionData.length }}</b>
                <small>Questions</small>
              </div>
            </div>
            <div class="bordered-info">
              <label>Owner</label>
              <div>{{ userData.name }}</div>
              <label>App ID</label>
              <div>{{ applicationData.application_id }}</div>
              <label>Published</label>
              <div>{{ applicationData.published_date == null ? 'N/A' : applicationData.published_date }}</div>
            </div>
          </div>
        </div>
        <div>
          <h1>{{ applicationData.title }}</h1>
          <div v-if="applicationData.is_free">
            Free
          </div>
          <div v-else>
            <div class="unit-pricing">{{  `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.single_unit_pricing}/unit` }}</div>
            <small class="monthly-pricing">{{ `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.monthly_subscription_pricing}/month subscription` }}</small>
          </div>
          <small>{{ applicationData.info }}</small>

          <div id="plan-info-page-container">
            <div v-if="applicationData.is_free" id="free-plan">
              <h5>Free</h5>
              <P>Unlimited access to the app, use as many as needed.</P>
            </div>
            <div v-else id="payed-plan">
              <div v-if="applicationData.single_unit_pricing" id="unit-plan-page-container" @click="paymentPlan = 'unit'">
                <div class="type-header">
                  <b>Purchase By Unit</b>
                  <input type="radio" v-model="paymentPlan" name="payment-plan" value="unit" />
                </div>
                <div class="price-header">
                  <span>{{  `${getCurrencySymbol(applicationData.currency_code)}${applicationData.single_unit_pricing}` }}</span> per Unit 
                </div>
              </div>
              <div v-if="applicationData.monthly_subscription_pricing" id="monthly-plan-page-container" @click="paymentPlan = 'monthly'">
                <div class="type-header">
                  <b>Purchase By Subscription</b>
                  <input type="radio" v-model="paymentPlan" name="payment-plan" value="monthly" />
                </div>
                <div class="price-header">
                  <span>{{ `${getCurrencySymbol(applicationData.currency_code)}${applicationData.monthly_subscription_pricing}` }}</span> monthly
                </div>
              </div>
            </div>
            <button class="primary-button-sm-global" @click="openModal('purchase-modal')">Checkout</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import instance from '../axios.js';
  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationID: null,
        applicationData: null,
        questionData: null,
        categorizationsData: null,
        userData: null,
        paymentPlan: 'monthly',/* monthly or unit or free */
        paymentMethod: 'credit',
        expirationYears: Array.from(
          { length: 25 },
          (_, i) => new Date().getFullYear() + i
        ),
        paymentInputObject: {
          numberOfUnits: 0
        },
      }
    },
    async created() {
      try {
        this.applicationID = this.$route.params.applicationID;
        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.applicationID}`);
        this.applicationData = applicationResponse.data;
        let questionsResponse = await instance.get(`/api/question-admin/application/${this.applicationID}`)
        let categorizations = await instance.get(`/api/appAdmin/categorization/${this.applicationID}`);
        this.questionData = [...questionsResponse.data];
        this.categorizationsData = {...categorizations.data};
        let userResponse = await instance.get(`/api/user/${applicationResponse.data.owner_uuid}`);
        this.userData = userResponse.data;
      } catch (e) {
        console.error(e);
      }
    },
    computed: {
      totalPrice() {
        return this.applicationData.single_unit_pricing * this.paymentInputObject.numberOfUnits
      }
    },
    methods: {
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      goToActivities() {
        this.$router.push(`/activities`);
      },
      getURLImage(file) {
        if (file != null && file != '') {
          return URL.createObjectURL(file);
        } else {
          return null;
        }
      },
      async testingPayment() {
        try {
          if (this.applicationData.is_free) {
            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'free',
              units_purchased: null,
              units_used: null,
            })
          }
          else if (this.paymentPlan == 'monthly') {
            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'monthly',
              units_purchased: null,
              units_used: null,
            })
          } else if (this.paymentPlan == 'unit') {
            if (this.paymentInputObject.numberOfUnits == '' || parseInt(this.paymentInputObject.numberOfUnits) <= 0) {
              alert('Please Insert a Unit number above 0 you would like to purchase.');
              return;
            }

            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'unit',
              units_purchased: parseInt(this.paymentInputObject.numberOfUnits),
              units_used: 0,
            })
          }
          this.closeModal('purchase-modal');
          this.openModal('receipt-modal');
        } catch (e) {
          console.error(e);
        }
      },
      formatDate(isoString) {
        const date = new Date(isoString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      getCurrencySymbol(currencyCode) {
        const currencyMap = {
            USD: "$",
            EUR: "€",
            GBP: "£",
            JPY: "¥",
            CNY: "¥",
            RUB: "₽"
        };
        return currencyMap[currencyCode] || "";
      },
      customQuantityChooser(operation) {
        if (operation == 'increment') {
          this.paymentInputObject.numberOfUnits++;
        } else if (operation == 'decrement') {
          if (this.paymentInputObject.numberOfUnits - 1 < 0) {
            return;
          }
          this.paymentInputObject.numberOfUnits--;
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #purchase-modal {
    padding: 0;

    .purchase-modal-content {
      color: globalSharedVariables.$grey-700;

      h4 {
        color: globalSharedVariables.$grey-900;
      }

      .layout-left {
        width: 800px;
        padding: 1rem;
      }

      .layout-right {
        width: 400px;
        padding: 1rem;
        border-radius: 10px;
        background-color: globalSharedVariables.$grey-50;
        border-left: globalSharedVariables.$grey-200 1px solid;

        .total-price {
          display: flex;
          justify-content: space-between;
          font-size: 1.5rem;
          font-weight: 700;
          margin-top: 1rem;
        }
      }

      #free-container {
        display: flex;
      }

      #cost-container {
        display: flex;

        #payment-info-container {
          .payment-method-card {
            border-radius: 10px;
            padding: .5rem;
            border: solid 1px globalSharedVariables.$grey-300;
            display: inline-flex;
            justify-content: space-between;
            width: 260px;
            margin-right: 10px;
            font-size: .9rem;
            cursor: pointer;
            margin-bottom: 1rem;
            color: globalSharedVariables.$grey-800;
            font-weight: 700;

            > *:nth-child(2) {
              display: flex;
              align-items: center;
            }

            svg {
              height: 20px;
              margin-bottom: 5px;
            }

            &.selected-payment-method {
              border: solid 1px globalSharedVariables.$brand-400;
              background-color: globalSharedVariables.$brand-50;
              color: globalSharedVariables.$brand-700;
            }
          }

          #payment-info {
            display: grid;
            grid-template-columns: auto auto;
            column-gap: 2rem;

            .span2Col {
              grid-column: span 2;
            }

            input {
              width: 100%;
            }
          }

          #payPal-info {
            svg {
              width: 100px;
              fill: #193F88;
              cursor: pointer;
            }
          }
        }

        #plan-info-checkout-container {
          #monthly-plan-container, #unit-plan-container {
            background-color: white;
            margin: 10px 0;
            cursor: pointer;
            display: grid;
            grid-template-rows: auto auto;

            .type-header {
              border: solid 1px globalSharedVariables.$grey-400;
              border-radius: 5px 5px 0 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
              color: globalSharedVariables.$grey-700;
              padding: .5rem;

              &:has(input[type="radio"]:checked) {
                border: solid 1px globalSharedVariables.$brand-400;
                background-color: globalSharedVariables.$brand-50;
                color: globalSharedVariables.$brand-800;
                border-radius: 10px 10px 0 0;
              }
            }

            .price-header {
              border: solid 1px globalSharedVariables.$grey-400;
              border-radius: 0 0 10px 10px;
              color: globalSharedVariables.$grey-600;
              padding: .5rem;

              > span {
                font-size: 2rem;
                font-weight: 700;
              }
            }
          }
        }
      }
    }
  }

  #dynamic-page-grid {
    display: grid;
    grid-template-columns: 450px 1fr;
    column-gap: 3rem;

    a {
      color: globalSharedVariables.$grey-900;
    }

    small {
      display: block;
      color: globalSharedVariables.$grey-600;
    }

    img {
      width: 100%;
      border-radius: 5px;
    }

    #application-base-info {
      padding: 1rem;

      .column-grid {
        display: grid;
        grid-template-columns: 30px 1fr;

        > div:nth-child(1) {
          display: flex;
          align-items: center;
        }
      }

      .bordered-info {
        margin-top: 1rem;
        border: solid #DDDDDD 1px;
        padding: 1rem;
        border-radius: 5px;

        label {
          color: #595959;
          margin: 0;
        }
      }

      small {
        display: block;
        color: globalSharedVariables.$grey-600;
      }
    }

    #preview-button {
      margin: 1rem 0;

      button {
        border: solid 1px black;
        border-radius: 5px;
        width: 100%;
      }
    }

    #plan-info-page-container {
      #free-plan {
        border: solid 1px globalSharedVariables.$brand-400;
        background-color: globalSharedVariables.$brand-100;
        border-radius: 5px;
        padding: 1rem;
        margin: 10px 0;
        cursor: pointer;
      }

      #payed-plan {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        column-gap: 1rem;

        #monthly-plan-page-container, #unit-plan-page-container {
          margin: 10px 0;
          cursor: pointer;
          display: grid;
          grid-template-rows: 1fr 1fr;

          .type-header {
            border: solid 1px globalSharedVariables.$grey-200;
            border-radius: 5px 5px 0 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: globalSharedVariables.$grey-700;
            padding: .5rem;

            &:has(input[type="radio"]:checked) {
              border: solid 1px globalSharedVariables.$brand-400;
              background-color: globalSharedVariables.$brand-50;
              color: globalSharedVariables.$brand-800;
              border-radius: 10px 10px 0 0;
            }
          }

          .price-header {
            border: solid 1px globalSharedVariables.$grey-200;
            border-radius: 0 0 10px 10px;
            color: globalSharedVariables.$grey-600;
            padding: .5rem;

            > span {
              font-size: 2rem;
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .custom-quantity-input {
    $change-button-width: 50px;
    display: grid;
    grid-template-columns: $change-button-width 50px $change-button-width;

    button {
      width: $change-button-width;
      height: 30px;
      border: none;
      background-color: globalSharedVariables.$grey-100;
      cursor: pointer;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: none;
      font-size: 1.5rem;
    }

    button:nth-child(1) {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-right: globalSharedVariables.$grey-300 solid 1px;
    }

    button:nth-child(3) {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-left: globalSharedVariables.$grey-300 solid 1px;
    }

    .custom-quantity-input-number {
      min-width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: globalSharedVariables.$grey-100;
    }
  }
</style>
